module.exports = __webpack_public_path__ + "img/065_thumbnail.fed96bdb.jpg";